// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pZH3","type":"styles_type__2GP5u","choices":"styles_choices__1_TKf"};